// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0766d07e","535":"6d32fb0b","655":"fd8aceb1","703":"38afca75"}[chunkId] + ".chunk.js";
};